import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";

const API = "/api";

// Module-level flag survives React StrictMode double-mount (useRef does NOT)
let isProcessing = false;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (isProcessing) return;
    isProcessing = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

      if (!sessionId) {
        isProcessing = false;
        navigate("/login", { replace: true });
        return;
      }

      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        await login(res.data);
        isProcessing = false;
        navigate("/dashboard", { replace: true });
      } catch {
        isProcessing = false;
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-zinc-300 border-t-zinc-900 rounded-full animate-spin" />
        <p className="text-sm text-zinc-500 font-body">Signing you in...</p>
      </div>
    </div>
  );
}
